/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_WhatInputs */

const cs_gdpr_col_what = /** @type {(inputs: Gdpr_Col_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co`)
};

const en_gdpr_col_what = /** @type {(inputs: Gdpr_Col_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What`)
};

/**
* | output |
* | --- |
* | "What" |
*
* @param {Gdpr_Col_WhatInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_what = /** @type {((inputs?: Gdpr_Col_WhatInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_WhatInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_what(inputs)
	return cs_gdpr_col_what(inputs)
});